import React, { useState, useEffect} from 'react';
import NewEvent from './NewEvent.js' ; 

import {Button, List, ListItem, ListItemAvatar, Avatar, ListItemText, IconButton, Container, Box} from '@mui/material';
import { Add, ChevronRight} from '@mui/icons-material';
import TopAppBar from './TopAppBar' ;

//import axios from 'axios';

import { useNavigate, useParams } from 'react-router-dom';

import * as Config from '../Config.js'; 
import * as Helper from '../Helper.js'; 


import { useTranslation } from "react-i18next";

// param type indicates my events (type = 'mine') or friend events (type= 'friend')


function MyEventsScreen () {
    const { t } = useTranslation();
    const [events, setEvents] = useState([]) ;
    const [addTrip, setAddTrip] = useState(false) ;
    const navigate = useNavigate();
    const {type} = useParams() ;

    useEffect(() => {
        console.log("MyEventsScreen useEffect invoked") ;
        listEvents() ;
        // the next line prevents the useEffect excessive warning
        // eslint-disable-next-line react-hooks/exhaustive-deps    
    }, [])
    
    const listEvents = () => {
        console.log('listEvent invoked') ;
        let link = type === 'mine' ? '/site/events' : '/site/friend_events' ;

        fetch(Config.apiUrl  + link,  {
            credentials: 'include',
        })
        .then(response => response.json())
        .then( (res) => {
            console.log(res) ;
            if (res.success) {
                console.log(res.data) ;
                setEvents(res.data) ;
            } else {
                console.log(res.error) ;
                navigate('/') ;
            }
        })
        .catch((e) => navigate('/'))
    }


   // componentWillUnmount() {
   //     this._unsubscribe();   
   //  }

    
    const eventScreen = (event) => {
        console.log('EVENT') ;
        console.log(event) ;
        navigate('/event/'+event.id+'/'+type ) ;
    }
    
    // function passed to child component NewEvent
    const actionAddTrip = (val) =>  {
        setAddTrip(val) ;
        if (addTrip) {
            listEvents() ;
        }
    }
    
    const openInput = () => {
        setAddTrip(true)
    }

    return (
        
        <Container maxWidth="sm" style={{justifyContent: 'center'}}>
            <TopAppBar 
                title= {type === 'mine' ? t("My Events") : t("Friend Events")} 
                returnLink="/"
                />
            { type === 'mine' &&  !addTrip &&
                <Box
                    textAlign = "center"
                    marginTop = "5%"
                >
                    <Button 
                        startIcon={<Add />}
                        onClick={openInput}
                        variant="outlined"
                        >{t('Add Event')}
                    </Button>
                </Box>    
                }

            { type === 'mine'   && addTrip &&
                  <NewEvent addTrip = {actionAddTrip} /> 
            }

            { !addTrip &&
                <List>
                {events.map( (item, i) => 
                    <ListItem
                        key = {i}
                        onClick={() => eventScreen(item)}
                        secondaryAction={
                            <IconButton edge="end">
                                <ChevronRight />
                            </IconButton>
                        }
                        >
                        <ListItemAvatar>
                            <Avatar sx={{width : 100, height: 100}}  src={Config.imageDir + item.url} />
                        </ListItemAvatar>
                        <ListItemText
                            sx = {{marginLeft: '2%'}}
                            primary={ type==='mine' ? item.name : item.friend[0].name + ': ' + item.name}
                            secondary={Helper.dateFr(item.date)}
                        />
                    </ListItem>
                    )
                }
                </List>
            }

        </Container>
    );
}

export default MyEventsScreen ;